import React, {useState, useRef, useEffect }  from 'react';
import './index.scss';
import { pathServer } from '../../../shared/constants/Constants';
import { Button } from '../../atoms';
import DropDown from '../../molecules/dropDown/DropDown';
import { DropzoneNewsLetter } from '../../molecules';
import NewsItemCardFull from '../../organisms/newsItemCardFull/NewsItemCardFull';
import JoditEditor from "jodit-react";

const NewsItemDetail = React.forwardRef(({className,onGoBack,listCategories,onSaveNews, onChangeNews, newsCreate, loadSave, isEdit, onEditNews }, ref) => {

  const [showPreview, setShowPreview] = useState(false);
	const editor = useRef(null);
	const [content, setContent] = useState('');

  const config = {
    askBeforePasteFromWord:false,
    askBeforePasteHTML:false,
		readonly: false // all options from https://xdsoft.net/jodit/doc/
	}

  const goBack = () => {
    if(showPreview){
      onGoBack();
    }else{
      // todo limpiar variable
      onGoBack()
    }
  };

  const onSave = async ()=>{
    try{

      let isSaved ;
      if(isEdit){
         isSaved =  await onEditNews()
      }else{
         isSaved =  await  onSaveNews();
      }

     if(isSaved){
       setShowPreview(true)
     }

    }catch (error){

    }
  };

  return (
    <div className="container-news-item" ref={ref}>
      <div className={`principal-container`}>
        <div className={`pc-left`}>
          <a href='#' onClick={goBack}><img src={`${pathServer.PATH_ICONS}icon_arrow_back.svg`} width="40%" alt="flecha atrás"/></a>
        </div>
        {
          !showPreview ?
            <div className={`pc-right`}>
              <h2>DETALLE DE LA PUBLICACIÓN</h2>
              <div className={`first-container d-flex`}>
                <div className={`fc_title`}>
                  <div>
                    <label>Título</label>
                  </div>
                  <input type='text' onChange={(e)=>onChangeNews("title", e.target.value)} value={newsCreate.title}/>
                </div>
                <div className={`fc_author`}>
                  <div>
                    <label>Autor</label>
                  </div>
                  <input type='text' onChange={(e)=>onChangeNews("author", e.target.value)} value={newsCreate.author}/>
                </div>
              </div>
              <div className={`category-container`}>
                <div>
                  <label>Categoría</label>
                </div>
                <DropDown
                  options={listCategories}
                  onSelectValue = {(e)=>onChangeNews("idCategory", e.target.value)}
                  selectedValue={newsCreate.idCategory}
                />
              </div>
              <div className="paragraph-container">
                <div>
                  <label>Contenido</label>
                </div>
                <JoditEditor
                  ref={editor}
                  value={content || newsCreate.description}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => onChangeNews("description", newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => {}}
              />
                {/*<div className="content-container"/>*/}
              </div>
              <div className="preview-image-container">
                <label>Foto</label>
                <DropzoneNewsLetter selectFile={(file)=>onChangeNews("photo",file)} isEdit={isEdit} imgEdit ={newsCreate.photo}/>
              </div>
              <div className={`pl_button-container d-flex`}>
                <Button onClick={onSave} loading={loadSave}>Guardar</Button>
              </div>
            </div> :
            <div>
              <NewsItemCardFull
                news ={newsCreate}
              />
            </div>
        }
      </div>
    </div>
  );
});

NewsItemDetail.displayName = 'NewsItemDetail';

NewsItemDetail.defaultProps = {

};

NewsItemDetail.propTypes = {

};

export default NewsItemDetail;
